import { getKeywords } from "./consts";

const moo = require("moo");
// Keywords could be ambiguously parsed as part of an identifier so we define them here.
const keywords = getKeywords();
// The lexer contains all our rules.
export const lexer = moo.compile([
    // Symbols
    { name: "ws", match: /[ \t]+/ },
    { name: "@", match: "@" },
    { name: "#", match: "#" },
    // Grouping
    { name: "(", match: "(" },
    { name: ")", match: ")" },
    { name: "[", match: "[" },
    { name: "]", match: "]" },
    { name: ",", match: "," },
    // Boolean operators
    { name: "&", match: "&" },
    { name: "|", match: "|" },
    { name: "^", match: "^" },
    // Math operators
    { name: "add", match: "+" },
    { name: "sub", match: "-" },
    { name: "div", match: "/" },
    { name: "mul", match: "*" },
    // Comparison operators
    { name: "not_eq", match: /<>|!=/ },
    { name: "lte", match: "<=" },
    { name: "gte", match: ">=" },
    { name: "lt", match: "<" },
    { name: "gt", match: ">" },
    { name: "eq_algebraic", match: "==" },
    { name: "eq", match: "=" },
    // Empty & Contains
    { name: "is_empty", match: "is empty" },
    { name: "is_not_empty", match: "is not empty" },
    { name: "does_not_contain", match: "does not contain" },
    // Identifiers and keywords
    {
        name: "identifier",
        match: /\$?[a-z_][@.a-z0-9_]*/,
        /**
         * We define the keywords here so that if they match the full identifier,
         * it will be parsed with the correct type instead of "identifier".
         *
         * Not using this parameter would break names containing keywords.
         *
         * For example the term COLOR should parse as (identifier: "COLOR")
         * instead of (identifier: "COL", or: "OR").
         */
        keywords,
    },
    ...Object.keys(keywords).map((name) => ({ name, match: keywords[name] })),
    // Numbers
    { name: "float", match: /[0-9]+\.[0-9]+/ },
    { name: "uint", match: /[0-9]+(?!\w)/ },
    { name: "word", match: /[0-9][a-z0-9_]+/ },
    // New line
    { name: "nl", match: /(?:\r\n?|\n)+/, lineBreaks: true },
]);
